import React, { useState, useCallback } from "react";
import { Redirect } from "react-router-dom";

import { Form, Dropdown } from "semantic-ui-react";

import { producaov2 as api } from "../../../../../services/apis";

import swal from "sweetalert";
import { StyledLabel, StyledButton } from "./styles";
import { vacancySchema } from "./Validation/VacancyValidation";
import { contractTypeUtils, utils, workLocation } from "../utils";

const CreateVacancyForm = () => {
  const [name, setName] = useState({ value: "", error: "" });
  const [modelActuation, setModelActuation] = useState({
    value: "",
    error: "",
  });
  const [modelContract, setModelContract] = useState({ value: "", error: "" });
  const [location, setLocation] = useState({ value: "", error: "" });
  const [vacancyLink, setVacancyLink] = useState({ value: "", error: "" });
  const [redirect, setRedirect] = useState(false);

  const validateField = async (fieldName, value) => {
    try {
      await vacancySchema.validateAt(fieldName, { [fieldName]: value });
      return "";
    } catch (error) {
      return error.message;
    }
  };

  const handleNameChange = async e => {
    const value = e.target.value;
    const error = await validateField("name", value);
    setName({ value, error });
  };

  const handleLinkChange = async e => {
    const value = e.target.value;
    const error = await validateField("vacancy_link", value);
    setVacancyLink({ value, error });
  };

  const submitForm = async e => {
    e.preventDefault();
    try {
      await vacancySchema.validate(
        {
          name: name.value,
          vacancy_link: vacancyLink.value,
          model: modelActuation,
          type: modelContract,
          location: location,
        },
        { abortEarly: false }
      );

      await api.post("voitto-vacancies", {
        role_position: name.value,
        vacancy_link: vacancyLink.value,
        location: location,
        model: modelActuation,
        type: modelContract,
      });

      setName({ value: "", error: "" });
      setVacancyLink({ value: "", error: "" });
      setModelActuation("");
      setModelContract("");
      setLocation("");

      swal("Nova vaga criada", "", "success");
      setRedirect(true);
    } catch (error) {
      if (error) {
        error.inner.forEach(e => {
          swal(
            "Preencha todos os campos ",
            "Se o erro persistir, contacte o TI",
            "error"
          );

          if (e.path === "name") {
            setName(prev => ({ ...prev, error: e.message }));
          } else if (e.path === "vacancy_link") {
            setVacancyLink(prev => ({ ...prev, error: e.message }));
          }
        });
      }
      console.error("Erro ao enviar formulário:", error);
    }
  };

  return (
    <>
      {redirect && <Redirect to="/admin/rh/vacancies" />}
      <Form>
        <Form.Field>
          <StyledLabel>Nome da Vaga</StyledLabel>
          <Form.Input
            name="name"
            placeholder="Ex: Analista Junior de Gestão"
            value={name.value}
            onChange={handleNameChange}
          />
        </Form.Field>
        {name.error && (
          <p
            style={{ marginBottom: "10px", fontSize: "12px", color: "#dd0000" }}
          >
            {name.error}
          </p>
        )}
        <Form.Field>
          <StyledLabel>Tipo de atuação</StyledLabel>
          <Dropdown
            placeholder="Selecionar"
            fluid
            selection
            options={utils}
            onChange={e => setModelActuation(e.target.innerText)}
          />
        </Form.Field>
        <Form.Field>
          <StyledLabel>Modelo de contrato</StyledLabel>
          <Dropdown
            placeholder="Selecionar"
            fluid
            selection
            options={contractTypeUtils}
            onChange={e => setModelContract(e.target.innerText)}
          />
        </Form.Field>
        <Form.Field>
          <StyledLabel>Cidade de atuação</StyledLabel>
          <Dropdown
            placeholder="Selecionar"
            fluid
            selection
            options={workLocation}
            onChange={e => setLocation(e.target.innerText)}
          />
        </Form.Field>
        <Form.Field>
          <StyledLabel>Link da vaga na Sólides</StyledLabel>
          <Form.Input
            name="link"
            placeholder="Ex: https://grupovoitto.vagas.solides.com.br/vaga/309565?_...."
            value={vacancyLink.value}
            onChange={handleLinkChange}
          />
        </Form.Field>
        {vacancyLink.error && (
          <p
            style={{ marginBottom: "10px", fontSize: "12px", color: "#dd0000" }}
          >
            {vacancyLink.error}
          </p>
        )}

        <StyledButton type="submit" onClick={submitForm}>
          <i class="plus icon"></i> Criar
        </StyledButton>
      </Form>
    </>
  );
};

export default CreateVacancyForm;
